module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="loading">\r\n\t<span>Loading</span>\r\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/loading.tmpl
 ** module id = 11
 ** module chunks = 0
 **/